import Rewind from "../../components/rewind.gjs";

export default <template><Rewind @user={{@controller.model}} /></template>
